import { render, staticRenderFns } from "./consult_release.vue?vue&type=template&id=707921ad&"
import script from "./consult_release.vue?vue&type=script&lang=js&"
export * from "./consult_release.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports